import { ReactNode } from "react"
import styled from "styled-components"

interface IconProps{
    icon: any
    label: string
}

const Container = styled.div`
`

export default function Icon({icon, label }:IconProps) {
    return <Container className="row p-0 m-0">
        <div className="row p-0 m-0">
            {icon}
        </div>
        <div className="row p-0 m-0 text-center">
            {label}
        </div>
    </Container>
}